import React, { useMemo } from "react";
import FormInputs from "../../../components/UI/FormInputs";

const CustomMatrix = (props) => {
    const { field, setFormState, formState,setIsFormDirty } = props;
   
    let value = formState?.[field.id];
    if (typeof value === 'string') {
        try {
            const parsed = JSON.parse(value);
            //console.log('parsed',parsed);
            
            if (parsed && typeof parsed === 'object') {
                value = parsed;
            }
        } catch (e) {
        }
    }
    const handleOptionChange = (optionId, labelValue, isMultiple, forceSelect = false, forceUnselect = false) => {
      if (setIsFormDirty) {
        setIsFormDirty(true);
      }
      setFormState((prevState) => {
        const currentValue = value || {};
  
        if (isMultiple === 1) {
          const currentSelections = currentValue[optionId] || [];
          let updatedSelections = [];
  
          if (forceSelect) {
            // Force add the label
            updatedSelections = [...new Set([...currentSelections, labelValue])];
          } else if (forceUnselect) {
            // Force remove the label
            updatedSelections = currentSelections.filter((item) => item !== labelValue);
          } else if (currentSelections.includes(labelValue)) {
            // Remove if already selected
            updatedSelections = currentSelections.filter((item) => item !== labelValue);
          } else {
            // Add new selection
            updatedSelections = [...currentSelections, labelValue];
          }
  
          return {
            ...prevState,
            [field.id]: {
              ...currentValue,
              [optionId]: updatedSelections,
            },
          };
        } else {
          // Radio → single value
          return {
            ...prevState,
            [field.id]: {
              ...currentValue,
              [optionId]: forceUnselect ? "" : labelValue,
            },
          };
        }
      });
    };
  
    // ✅ Parse Table Header Options - use useMemo to recalculate when column_header changes
    const OPTIONS = useMemo(() => {
      let options = [];
      if (typeof field.column_header === "string") {
        try {
          let val = JSON.parse(field.column_header);
          if (Array.isArray(val)) {
            options = val.map((v) => {
              const label = (typeof v === 'string' ? v : v?.value) ?? "";
              let color = (typeof v === 'object' && v?.color) ? v.color : "";
              return {
                label: label,
                color: color,
                style: {},
              };
            });
          } else {
            options = [];
          }
        } catch (e) {
          options = [];
        }
      }
      return options;
    }, [field.column_header]);

    // Generate CSS for all checkbox/radio colors - use useMemo to recalculate when field or OPTIONS change
    const colorStyles = useMemo(() => {
      if (!field.options || !OPTIONS.length) return '';
      
      let cssRules = [];
      field.options.forEach((opt) => {
        OPTIONS.forEach((option) => {
          const uniqueId = `${field.id}_${opt.id}_${option.label.replace(/\s+/g, '_').replace(/[^a-zA-Z0-9_]/g, '')}`;
          // Use the color from option (which already includes fallback for "Positive")
          const color = option.color || "";
          
          if (color) {
            // Enhanced CSS with better specificity for both checkbox and radio
            cssRules.push(`
              input#${uniqueId}[type="checkbox"]:checked,
              input#${uniqueId}[type="radio"]:checked {
                background-color: ${color} !important;
                border-color: ${color} !important;
                accent-color: ${color} !important;
              }
              input#${uniqueId}[type="checkbox"]:checked::after,
              input#${uniqueId}[type="radio"]:checked::after {
                background-color: ${color} !important;
              }
              input#${uniqueId}[type="checkbox"]:focus,
              input#${uniqueId}[type="radio"]:focus {
                box-shadow: 0 0 0 0.15rem ${color}40 !important;
                border-color: ${color} !important;
              }
              input#${uniqueId}[type="checkbox"]:checked:focus,
              input#${uniqueId}[type="radio"]:checked:focus {
                box-shadow: 0 0 0 0.15rem ${color}40 !important;
              }
            `);
          }
        });
      });
      return cssRules.join('\n');
    }, [field.id, field.options, OPTIONS]);
    // console.log(OPTIONS,OPTIONS);
    // ✅ Handle N Click → Select or Unselect "Negative" or "Normal" Column
  const handleNormalClick = () => {
    // Find the matching header index (Negative/Normal)
    const targetHeader = OPTIONS.find(
      (opt) =>
        opt.label.toLowerCase() === "negative" ||
        opt.label.toLowerCase() === "normal"
    );

    if (!targetHeader) return;

    const labelToSelect = targetHeader.label;

    // Check if ALL rows are already selected for this label
    const allSelected = field.options.every((opt) => {
      const currentVal = value?.[opt.id];
      if (opt.ismultiple === 1) {
        return currentVal?.includes(labelToSelect);
      } else {
        return currentVal === labelToSelect;
      }
    });
    setIsFormDirty(true);

    // ✅ Update all rows in bulk
    setFormState((prevState) => {
      const currentValue = value || {};
      const updated = { ...currentValue };

      field.options.forEach((opt) => {
        if (opt.ismultiple === 1) {
          if (allSelected) {
            // Uncheck column for all rows
            updated[opt.id] = (updated[opt.id] || []).filter((item) => item !== labelToSelect);
          } else {
            // Select column for all rows
            updated[opt.id] = [...new Set([...(updated[opt.id] || []), labelToSelect])];
          }
        } else {
          updated[opt.id] = allSelected ? "" : labelToSelect;
        }
      });

      return {
        ...prevState,
        [field.id]: updated,
      };
    });
  };
    
    return (
        <div className="card w-100 mb-0 pb-2 shadow-none border-0">
         <style>{colorStyles}</style>
         {!props.isExam && (
         <div className="card-header sh_subaccordionheader d-flex align-items-center">
         <h6 className="text-sm mb-0 d-flex align-items-center">
           {field.label}
           {field.is_required ? <span className="text-danger ms-1">*</span> : ""}
         </h6>
         <span
           className="sh_emrbadge normal cursor-pointer ms-3"
           style={{padding: '2px 6px'}}
           title="Mark All Normal"
           onClick={handleNormalClick}
         >
           N
         </span>
          </div>
            )}

            <div className="card-body py-0 px-0">
                <table className="table table-bordered table-sm mb-0">
                    <thead className="thead-light">
                        <tr>
                            <th style={{ width: "60%" }} className="text-start">

                            </th>
                            {OPTIONS.map((item,ind)=>
                                  (<th key={ind} className="text-center">{item.label}</th>)
                            )}
                        </tr>
                    </thead>
                    <tbody>
                        {field.options.map((opt, idx) => {
                            const selected =
                              opt.ismultiple===1?value?.[opt.id] || [] :  value?.[opt.id] || "";
                            
                            return (
                                <tr key={opt.id}>
                                    <td className="align-middle sh_emrradiotabletd">
                                        {opt.value || `Option ${idx + 1}`}
                                    </td>
                                    {OPTIONS.map((option) => {
                                        const isChecked = opt.ismultiple===1 ? selected.includes(option.label) : selected === option.label;
                                        // Use the color from option (which already includes fallback for "Positive")
                                        const checkboxColor = option.color || "";
                                        const uniqueId = `${field.id}_${opt.id}_${option.label.replace(/\s+/g, '_').replace(/[^a-zA-Z0-9_]/g, '')}`;
                                        
                                        // Inline style as fallback for better browser compatibility
                                        const inputStyle = isChecked && checkboxColor ? {
                                            accentColor: checkboxColor,
                                            backgroundColor: checkboxColor,
                                            borderColor: checkboxColor
                                        } : {};
                                        
                                        return (
                                        <td
                                            key={`${option.label}-${checkboxColor}`}
                                            className="text-center align-middle"
                                        >
                                            <div className="form-check d-flex justify-content-center mb-0">
                                            <FormInputs 
                                                type={opt.ismultiple===1?'Checkbox':'Radio'}
                                                className={"form-check-input cursor-pointer"}
                                                name={`${field.id}_${opt.id}`}
                                                id={uniqueId}
                                                value={isChecked}
                                                style={inputStyle}
                                                changeHandler={() =>
                                                    handleOptionChange(opt.id, option.label,opt.ismultiple) 
                                                }
                                                />
                                            </div>
                                        </td>
                                    )})}
                                </tr>
                            );
                        })}
                    </tbody>
                </table>
            </div>
        </div>
    );
};

export default CustomMatrix;
